import { defaultTo, includes, path, pipe, split } from 'ramda';

/**
 * @example
 * const IncludesCheckmarkExample = ()=>{
 *   ...
 *   const data = [
 *     { container:
 *       { subContainer: ['FOO_1', 'FOO_2'] }
 *     },
 *     { container:
 *       { subContainer: ['FOO_2'] }
 *     },
 *   ]
 *   <DataGrid
 *     ...
 *     rows={data}
 *     columns={[
 *       {
 *         headerName: 'foo 1 column',
 *         field: 'FOO_1',
 *         type: 'boolean',
 *         valueGetter: isFieldInArrayValueGetter('container.subContainer')
 *       }
 *    ]
 *   />
 * }
 *   // result: |foo 1 column|
 *   //         |     ✓      |
 *   //         |     x      |
 */
export const isFieldInArrayValueGetter = (nestedPath: string) => <R>(field: string, row: R & object) =>
    pipe<[object], string[] | undefined, string[], boolean>(
      path(split('.', nestedPath)),
      defaultTo([]),
      includes(field)
    )(row);
